// 每一档的颜色都有所区分，偏高（大于70%）、平均（30%~70%）、偏低（小于30%）（3个档次的划分规则均一样）。
export function getIntroOnCircle(d, fenmu=1){
  let val = d/fenmu;
  if (val >= 0.3 && val < 0.7) {
    return '历史适中'
  }else if(val >= 0.7){
    return '历史偏高'
  }else if(val < 0.3){
    return '历史偏低'
  }
}
